export default "__VITE_ASSET__DBtbR1ri__"